import { FC, useId } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Form, Radio, Space } from 'antd';
import styled from 'styled-components';

import { Button } from '@/shared/components';
import { useIsDesktop } from '@/shared/hooks/use-is-desktop';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { SelectBeneficiaryTypeModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../containers/ModalContainerV2';

type CreateMode = Parameters<SelectBeneficiaryTypeModalProps['onSubmit']>[0];

export const SelectBeneficiaryTypeModal: FC<SelectBeneficiaryTypeModalProps> = ({
  onSubmit,
  title,
}) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'selectBeneficiaryType' });

  const isDesktop = useIsDesktop();
  const modals = useModalsStore();
  const formId = useId();

  const { control, handleSubmit: formHandleSubmit } = useForm<{ mode: CreateMode }>();

  const handleSubmit = formHandleSubmit((values: { mode: CreateMode }) => {
    modals.closeModal();
    onSubmit(values.mode);
  });

  return (
    <ModalContainerV2 title={title ?? t('title')}>
      <Body>
        <Message>{t.rich('message')}</Message>
        <b>{t('label')}</b>

        <Form onFinish={handleSubmit} id={formId}>
          <Controller
            name="mode"
            control={control}
            rules={{ required: true }}
            render={({ field, fieldState }) => (
              <Form.Item validateStatus={fieldState.error ? 'error' : ''}>
                <Radio.Group {...field}>
                  <Space direction="vertical">
                    <Radio value={'withReg'}>{t.rich('option1')}</Radio>
                    <Radio value={'withourReg'}>{t.rich('option2')}</Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>
            )}
          />
        </Form>
      </Body>
      <ButtonWrapper>
        <Button text={t('btn')} isBlock={!isDesktop} onClick={handleSubmit} form={formId} />
      </ButtonWrapper>
    </ModalContainerV2>
  );
};

const Body = styled.div`
  padding: 24px 0 24px;
  display: grid;
  gap: 16px;
`;

const Message = styled.div`
  font-size: 14px;
  line-height: 20px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
`;
